module.exports = __webpack_public_path__ + "img/ga.3ab86bed.png";